export default __webpack_public_path__ + "static/media/outro-bg.78cd7ecf.png";